import React, { useState, useEffect } from "react";
import CustomSelect from '../components/Shared/CustomSelect';
import SweetAlert from "react-bootstrap-sweetalert";
import ReusableModal from "../components/Shared/ReusableModal"
import {
    Card,
    Table,
    OverlayTrigger,
    Tooltip,
    Button,
    Col,
    Row,
    Container,
    Form,
    Spinner,

} from "react-bootstrap";
import ActiveJobListings from '../components/JobApplication/ActiveJobListings'
import { isEmpty } from "lodash";
import Select from 'react-select';
import { getToken } from 'utils/tokenUtils'; // Update the path accordingly

function Home() {

    // ### STATE ###
    const [alert, setAlert] = React.useState(null);
    const hideAlert = () => setAlert(null);
    const [jobListings, setJobListings] = useState([]);
    const [filteredJobListings, setFilteredJobListings] = useState([]);
    const [jobLocations, setJobLocations] = useState([]);
    const [opportunityTypes, setOpportunityTypes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedLocationIds, setSelectedLocationIds] = useState([]);
    const [selectedOpportunityIds, setSelectedOpportunityIds] = useState([]);
    const [errors, setErrors] = useState([]);
    const [fullName, setFullName] = useState('');
    const [telephoneNumber, setTelephoneNumber] = useState('');
    const [email, setEmail] = useState('');
    const [location, setLocation] = useState('');
    const [locationLabel, setLocationLabel] = useState("");
    const [positionOfInterest, setPositionOfInterest] = useState('');
    const [cvFile, setCvFile] = useState(null);
    const [showExpressInterest, setShowExpressInterest] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [selectedLocations, setSelectedLocations] = useState([]);

    // ### HANDLERS ###
    const handleLoactionChange = (checked, id) => {
        if (checked) {
            setSelectedLocationIds([...selectedLocationIds, id]);
        } else {
            setSelectedLocationIds(selectedLocationIds.filter((selectedId) => selectedId !== id));
        }
    };

    const handleOpprotunityIds = (checked, id) => {
        if (checked) {
            setSelectedOpportunityIds([...selectedOpportunityIds, id]);
        } else {
            setSelectedOpportunityIds(selectedOpportunityIds.filter((selectedId) => selectedId !== id));
        }
    };


    const handleSelectedJob = (selectedJob) => {
        try {
            console.log(selectedJob);
        } catch (e) {
            console.log(e);
        }
    };

    const handleLocationItemChange = (selectedItems) => {
        setSelectedLocations(selectedItems);
    };

    // ### DATA FETCHES ##
    const fetchJobListings = async () => {
        try {
            setLoading(true);

            let url = `/fpmcareers/jobapplication/GetAllJobsAdvertised`;

            if (process.env.NODE_ENV === 'development') {
                url = `/jobapplication/GetAllJobsAdvertised`;
            }

            const token = getToken();
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            const body = await response.json();
            setJobListings(body);
            setFilteredJobListings(body);
            setLoading(false);
        } catch (err) {
            console.log(err)
        }
    };

    const fetchJobLocations = async () => {
        try {

            let url = `/fpmcareers/jobapplication/getJobLocations`;

            if (process.env.NODE_ENV === 'development') {
                url = `/jobapplication/getJobLocations`;
            }

            const token = getToken();
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            const body = await response.json();
            const data = body?.map((item) => { return { ...item, checked: false } });
            setJobLocations(data);
        } catch (err) {
            console.log(err)
        }
    };

    const fetchOpportunityTypes = async () => {
        try {

            let url = `/fpmcareers/jobapplication/getOpportunityTypes`;

            if (process.env.NODE_ENV === 'development') {
                url = `/jobapplication/getOpportunityTypes`;
            }

            const token = getToken();
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            const body = await response.json();
            const data = body?.map((item) => { return { ...item, checked: false } });
            setOpportunityTypes(data);
        } catch (err) {
        }
    };

    // ### HOOKS ###
    useEffect(() => {
        fetchJobListings();
        fetchJobLocations();
        fetchOpportunityTypes();
    }, []);


    useEffect(() => {
        setLoading(true);


        const filterListings = () => {
            const filteredListings = jobListings.filter((listing) => {

                // expression of intrest is inserted as job to keep in design with the cards
                const saveExpressionOfInterest = listing.id === -1 ? listing : null;

                const locationMatch =
                    selectedLocationIds.length === 0 ||
                    selectedLocationIds.includes(listing.jobLocation) ||
                    saveExpressionOfInterest !== null; // Include if Expression Of Interest to filtered list

                const opportunityMatch =
                    selectedOpportunityIds.length === 0 ||
                    selectedOpportunityIds.includes(listing.opportunityType) ||
                    saveExpressionOfInterest !== null; // Include if Expression Of Interest to filtered list

                return locationMatch && opportunityMatch;
            });

            setFilteredJobListings(filteredListings);
            setLoading(false);
        };

        const timeout = setTimeout(() => {
            filterListings();
        }, 500);

        return () => clearTimeout(timeout);
    }, [selectedLocationIds, selectedOpportunityIds, jobListings]);


    const openModal = () => {
        setShowModal(true);
        setShowExpressInterest(false);
    };

    const closeModal = () => {
        setShowModal(false);
        setShowExpressInterest(true);
    };

    function handleFileUpload(event) {
        const newFile = event.target.files[0];
        const maxSize = 5 * 1024 * 1024; // 5 MB

        if (newFile && newFile.size > maxSize) {
            alert("File size is too large. Maximum file size allowed is 5MB.");
            event.target.value = null; // clear the file input
            return;
        }

        const reader = new FileReader();

        reader.onload = function (event) {
            const base64String = btoa(
                new Uint8Array(event.target.result)
                    .reduce((data, byte) => data + String.fromCharCode(byte), '')
            );
            const documentFilename = newFile.name;
            setCvFile({
                base64: base64String,
                DocumentFilename: documentFilename
            });
        };

        reader.readAsArrayBuffer(newFile);
    }


    const onSubmitInterest = async () => {
        setIsSubmitting(true);

        const logErrors = validateForm();

        if (!Object.values(logErrors).some(Boolean)) {
            setErrors([]);

            let url = '/fpmcareers/jobapplication/ExpressionOfInterest';

            if (process.env.NODE_ENV === 'development') {
                url = '/jobapplication/ExpressionOfInterest';
            }

            const token = getToken();

            const response = await fetch(url, {
                method: 'post',
                headers: {
                    "Authorization": `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    FullName: fullName,
                    TelephoneNumber: telephoneNumber,
                    EmailAddress: email,
                    LocationOfInterest: locationLabel,
                    PointOfInterest: positionOfInterest,
                    Base64: cvFile?.base64,
                    DepotBasedLocations: selectedLocations.map(loc => loc.label).join(', ')
                }),
            });

            if (response.ok) {
                closeModal();
                setIsSubmitting(false);
                setAlert(
                    <SweetAlert
                        success
                        style={{ display: 'block', marginTop: '-100px', zIndex: '999999' }}
                        title='Success'
                        onConfirm={hideAlert}
                        confirmBtnBsStyle='success'
                    >
                        Thank you for expressing your interest in working at FP McCann. One of our team will be in contact.
                    </SweetAlert>)

                // Clear form data
                setFullName('');
                setTelephoneNumber('');
                setEmail('');
                setLocation('');
                setLocationLabel('');
                setPositionOfInterest('');
                setCvFile(null);
                setShowExpressInterest(false);
            } else {
                // error
                closeModal();
                setIsSubmitting(false);
            }
        }
        else {
            setErrors(logErrors);
            setIsSubmitting(false);
        }
    };


    function validateForm() {
        const errors = {
            fullName: isEmpty(fullName) && "Full Name is required",
            telephoneNumber:
                isEmpty(telephoneNumber)
                    ? "Telephone Number is required"
                    : telephoneNumber.length !== 11
                        ? "Telephone number must have 11 digits"
                        : "",
            positionOfInterest: isEmpty(positionOfInterest)
                ? "Position Of Interest is required"
                : "",
            location: location <= 0 ? "Location is required" : "",
            preferredWorkLocation: !selectedLocations || selectedLocations.length === 0
                ? "Preferred Work Locations is required"
                : ""

        };

        return errors;
    }

    const renderAdditionalBoxes = () => {

        // reuseable
        const generateLocationGroup = (label, options) => (
            <Form.Group>
                <Form.Label>{`Preferred Work Locations (${label}):`}</Form.Label>
                <Select
                    isMulti
                    options={options}
                    value={selectedLocations}
                    onChange={handleLocationItemChange}
                />
                {errors.preferredWorkLocation && (
                    <Form.Text className="text-danger">
                        <span className="star">*</span> {errors.preferredWorkLocation}
                    </Form.Text>
                )}
            </Form.Group>
        );

        const optionsNorthernIreland = [
            { value: "Armagh (BT60 2BL)", label: "Armagh (BT60 2BL)" },
            { value: "Craigall (BT51 5YF)", label: "Craigall (BT51 5YF)" },
            { value: "Enniskillen (BT74 7EQ)", label: "Enniskillen (BT74 7EQ)" },
            { value: "Knockloughrim (BT45 8QA)", label: "Knockloughrim (BT45 8QA)" },
            { value: "Lisnaskea (BT92 0HP)", label: "Lisnaskea (BT92 0HP)" },
            { value: "Loughside (BT40 2PN)", label: "Loughside (BT40 2PN)" },
            { value: "Macrete (BT41 3SE)", label: "Macrete (BT41 3SE)" },
            { value: "Mallusk (BT36 4QN)", label: "Mallusk (BT36 4QN)" },
            { value: "Omagh (BT79 0LA)", label: "Omagh (BT79 0LA)" },
        ];

        const optionsGreatBritain = [
            { value: "Alnwick (NE66 3JY)", label: "Alnwick (NE66 3JY)" },
            { value: "Byley (CW10 9RJ)", label: "Byley (CW10 9RJ)" },
            { value: "Cadeby (CV13 0BB)", label: "Cadeby (CV13 0BB)" },
            { value: "Ellistown (LE67 1ET)", label: "Ellistown (LE67 1ET)" },
            { value: "Grantham (NG31 9SP)", label: "Grantham (NG31 9SP)" },
            { value: "Littleport (CB6 1RA)", label: "Littleport (CB6 1RA)" },
            { value: "Lydney (GL15 4EJ)", label: "Lydney (GL15 4EJ)" },
            { value: "Uddingston (G71 6NE)", label: "Uddingston (G71 6NE)" },
            { value: "Weston Underwood (DE6 4PH)", label: "Weston Underwood (DE6 4PH)" },
        ];

        if (locationLabel === 'Northern Ireland') {
            return generateLocationGroup(locationLabel, optionsNorthernIreland);
        } else if (locationLabel === 'Great Britain') {
            return generateLocationGroup(locationLabel, optionsGreatBritain);
        }

        return null;
    };


    return (
        <>
            {alert}
            <ReusableModal
                show={showModal}
                handleClose={closeModal}
                title="Expression Of Interest"
                submitButtonText="SUBMIT"
                handleSubmit={onSubmitInterest}
                isSubmitting={isSubmitting}
                size="md">

                <Row>
                    <Col sm={4} md={12} style={{ marginBottom: 10 }}>
                        <Form.Group>
                            <Form.Label>Full Name:<span className="star">*</span></Form.Label>
                            <Form.Control
                                className={errors.fullName ? "form-control is-invalid custom-input squared-input" : "form-control custom-input squared-input"}
                                placeholder="Enter Full Name"
                                type="text"
                                value={fullName}
                                onChange={(e) => setFullName(e.target.value)}
                                style={{ borderRadius: '0' }}
                            />
                            {errors.fullName && <Form.Text className="text-danger"> <span className="star">*</span> {errors.fullName} </Form.Text>}
                        </Form.Group>
                    </Col>
                    <Col sm={4} md={12} style={{ marginBottom: 10 }}>
                        <Form.Group>
                            <Form.Label>Telephone Number:<span className="star">*</span></Form.Label>
                            <Form.Control
                                className={errors.telephoneNumber ? "form-control is-invalid custom-input squared-input" : "form-control custom-input squared-input"}
                                placeholder="Enter Telephone Number"
                                type="text"
                                pattern="[0-9]*"
                                value={telephoneNumber}
                                onChange={(e) => {
                                    const inputValue = e.target.value.slice(0, 11); // Limit input to 11 digits
                                    setTelephoneNumber(inputValue);
                                }}
                                style={{ borderRadius: '0' }}
                            />
                            {errors.telephoneNumber && <Form.Text className="text-danger"> <span className="star">*</span> {errors.telephoneNumber} </Form.Text>}
                        </Form.Group>

                    </Col>
                    <Col sm={4} md={12} style={{ marginBottom: 10 }}>
                        <Form.Group>
                            <Form.Label>Email Address (Optional):</Form.Label>
                            <Form.Control
                                className="form-control custom-input squared-input"
                                placeholder="Enter Email Address"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                style={{ borderRadius: '0' }}
                            />
                        </Form.Group>
                    </Col>
                    <Col sm={4} md={12} style={{ marginBottom: 10 }}>

                        <Form.Group>
                            <Form.Label>Location:<span className="star">*</span></Form.Label>
                            <CustomSelect
                                className="form-control"
                                withAll={false}
                                data={[
                                    { id: 0, label: "", value: "" }, // Blank row with value 0
                                    { id: 1, label: "Northern Ireland", value: "Northern Ireland" },
                                    { id: 2, label: "Great Britain", value: "Great Britain" }
                                ]}
                                value={location}
                                handleChange={(selectedLocation) => {
                                    setLocation(selectedLocation.value);
                                    setLocationLabel(selectedLocation.label);
                                    setSelectedLocations([]);
                                }}
                            />
                            {errors.location && <Form.Text className="text-danger"> <span className="star">*</span> {errors.location} </Form.Text>}
                        </Form.Group>
                    </Col>
                    <Col sm={4} md={12} style={{ marginBottom: 10 }}>
                        {renderAdditionalBoxes()}
                    </Col>
                    <Col sm={12} md={12} style={{ marginBottom: 10 }}>
                        <Form.Group>
                            <Form.Label>Position of Interest:<span className="star">*</span></Form.Label>
                            <Form.Control
                                className="form-control"
                                as="textarea"
                                rows={3}
                                maxLength="800"
                                style={{
                                    height: 'auto',
                                }}
                                value={positionOfInterest}
                                onChange={(e) => setPositionOfInterest(e.target.value)}
                            ></Form.Control>
                            {errors.positionOfInterest && <Form.Text className="text-danger"> <span className="star">*</span> {errors.positionOfInterest} </Form.Text>}
                        </Form.Group>
                    </Col>

                    <Col sm={12} md={12} style={{ marginBottom: 10 }}>
                        <Form.Label>CV Upload (Optional):</Form.Label>
                        <div className="file-upload-container">
                            <label htmlFor="file-upload" className="file-upload-label">
                                <i className="fas fa-cloud-upload-alt file-upload-icon"></i>
                                {cvFile ? cvFile.DocumentFilename : 'Click Here To Upload File'}
                                <p>Files Supported: PDF, DOC, DOCX.</p>
                            </label>
                            <input
                                id="file-upload"
                                type="file"
                                accept=".pdf, .doc, .docx"
                                onChange={handleFileUpload}
                                className="file-upload-input"
                            />
                        </div>
                    </Col>

                </Row>

            </ReusableModal>

            <Container fluid className="home">
                <Row className="banner">
                    <Container>
                        <Row className="grid md:grid-cols-2 grid-cols-1 gap-x-6 grid-reverse">
                            <Col className="content">
                                <h1> Why work for<br /> FP McCann?
                                </h1>
                                <h5>FP McCann aims to be an employer of choice by promoting respect for the individual and equality of opportunity. We believe that everyone should be treated based on personal merit and contribution throughout their FP McCann career journey.
                                    The diversity of our people, along with their skills and abilities, is the strength that helps us achieve our best.
                                    If you are a real team player, with a&nbsp;&quot;<b>can-do</b>&quot; attitude, then chances are you will enjoy a long and successful career with FP McCann.
                                </h5>
                            </Col>
                            <Col className="image">
                                <img src={require("assets/img/baseimage2.jpg").default} alt="image" />
                            </Col>
                        </Row>
                    </Container>
                </Row>



                <Row className="introduction home2">
                    <Container>
                        <div className="introduction-content">
                            <h1>-</h1>
                            <p style={{ fontSize: '24px' }}>
                                Take the next step, apply now!</p>
                            <Row>
                                <div className="vacancies-content">

                                    <Col xs={12} sm={12} md={3}>
                                        <div className="vacancies-left">
                                            <div className="vacancies-filter">
                                                <div className="vacancies-filter--item">
                                                    <h2 className="mb-4">Opportunity Type</h2>
                                                    <div className="d-flex flex-column align-items-start">
                                                        {opportunityTypes?.map((opp) => {
                                                            const countMatching = jobListings?.filter(job => job.opportunityType === opp.id);
                                                            return (
                                                                <Form.Check key={opp.id} className="mt-3">
                                                                    <Form.Check.Label>
                                                                        <Form.Check.Input
                                                                            onChange={(e) => handleOpprotunityIds(e.target.checked, opp.id)}
                                                                            type="checkbox" />
                                                                        <span className="form-check-sign"></span>
                                                                        {opp.value} ({countMatching.length})
                                                                    </Form.Check.Label>
                                                                </Form.Check>
                                                            );
                                                        })}

                                                    </div>
                                                </div>
                                                <div className="vacancies-filter--item">
                                                    <h2 className="mb-4">Location</h2>
                                                    <div className="d-flex flex-column align-items-start">
                                                        {jobLocations?.map((location) => {
                                                            const countMatching = jobListings?.filter(job => job.jobLocation === location.id);
                                                            return (
                                                                <Form.Check key={location.id} className="mt-2">
                                                                    <Form.Check.Label>
                                                                        <Form.Check.Input
                                                                            onChange={(e) => handleLoactionChange(e.target.checked, location.id)}
                                                                            type="checkbox" />
                                                                        <span className="form-check-sign"></span>
                                                                        {location.value} ({countMatching.length})
                                                                    </Form.Check.Label>
                                                                </Form.Check>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </Col>
                                    <Col xs={12} md={9}>
                                        <ActiveJobListings
                                            jobListings={filteredJobListings}
                                            isLoading={loading}
                                            handleSelectedJob={handleSelectedJob}
                                            openModal={openModal}
                                        />
                                    </Col>
                                </div>
                            </Row>
                        </div>
                    </Container>
                </Row>



                {/*{showExpressInterest && (*/}
                {/*    <div className="express-interest">*/}
                {/*        <button className="close-button" onClick={() => setShowExpressInterest(false)}>*/}
                {/*            X*/}
                {/*        </button>*/}
                {/*        <p>*/}
                {/*            If you don't see a suitable career listing, click the button below to express your interest in working with*/}
                {/*            us. We're always looking for talented individuals to join our team!*/}
                {/*        </p>*/}
                {/*        <button onClick={openModal} className="button-43">Express Interest</button>*/}
                {/*    </div>*/}
                {/*)}*/}

            </Container>
        </>
    );
}

export default Home;
